import { brandConfigs, Brands, Languages } from './brandConfig'

export { Brands, Languages }

export const DefaultBrand = Brands.MtnCameroonBLG

export function getBrandConfig(brandId) {
  return brandConfigs[brandId] || brandConfigs[DefaultBrand]
}

// Hosting origin (no trailing slash) -> brand, looked up against window.origin in
// functions/setBrandConfig.js. Both schemes are listed: header enrichment only arrives over http.
export const brandConfigMap = new Map([
  ['http://cm-mtn-play.blg.gg', Brands.MtnCameroonBLG],
  ['https://cm-mtn-play.blg.gg', Brands.MtnCameroonBLG],
  ['http://staging-cm-mtn-play.blg.gg', Brands.MtnCameroonBLG],
  ['https://staging-cm-mtn-play.blg.gg', Brands.MtnCameroonBLG],
  ['http://localhost:3400', Brands.MtnCameroonBLG]
])
